export default {"src":"/_next/static/media/arrow-bottom.653a9055.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};